<template>
  <div class="chart-type-ranking" :class="type === 'seller' && 'chart-type-ranking-seller'">
    <div class="chart-type-ranking-left">
      <div class="left-label">
        <!-- <span class="line"></span> -->
        <span class="left-label-type">
          <gj-tooltip :content="title" :text-line="1">
            {{title | defaultShow}}
        </gj-tooltip>
        </span>
      </div>
      <div class="left-inner">{{bigTypeRank | defaultShow}}</div>
    </div>
    <div class="chart-type-ranking-content">
      <div class="content-title">较昨日</div>
      <div class="content-inner">
        <span>{{Math.abs(bigTypeRank - lastDay)}}</span>
        <span class="icon-inner" v-if="bigTypeRank !== lastDay">
          <gj-icon 
          style="font-size: 12px;"
          :iconfont="dayStatus.iconfont" 
          :class="dayStatus.className"></gj-icon>
        </span>
      </div>
    </div>
    <div class="chart-type-ranking-content">
      <div class="content-title">较上周周期</div>
      <div class="content-inner">
        <span>{{Math.abs(bigTypeRank - lastWeek)}}</span>
        <span class="icon-inner" v-if="bigTypeRank !== lastDay">
          <gj-icon 
          style="font-size: 12px;"
          :iconfont="weekStatus.iconfont" 
          :class="weekStatus.className"></gj-icon>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    bigTypeRank: {
      type: [String, Number],
      default: ''
    },
    lastDay: {
      type: [String, Number],
      default: ''
    },
    lastWeek: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    dayStatus() {
      return {
        iconfont: this.bigTypeRank > this.lastDay ? 'iconshangsheng1' : 'iconxiajiang',
        className: this.bigTypeRank > this.lastDay ? 'is-success' : 'is-danger',
      }
    },
    weekStatus() {
      return {
        iconfont: this.bigTypeRank > this.lastWeek ? 'iconshangsheng1' : 'iconxiajiang',
        className: this.bigTypeRank > this.lastWeek ? 'is-success' : 'is-danger',
      }
    }
  },
  methods: {
    getIcon() {
      
    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/styles/variables';
.chart-type-ranking {
  display: flex;
  margin-left: 70px;
  .chart-type-ranking-left {
    .left-label {
      max-width: 110px;
      .left-label-type {
        display: inline-block;
        color: #333;
        font-weight: 600;
        font-size: 16px;
        line-height: 1;
        position: relative;
        &::before {
          content: "";
          display: block;
          position: absolute;
          left: -20px;
          // transform: translateX(-100%);
          width: 15px;
          height: 15px;
          background: $gj-color-primary;
          border-radius: 2px;
        }
      }
    }
    .left-inner {
      color: #333;
      font-weight: bold;
      font-size: 22px;
      margin-top: 5px;
    }
  }
  .chart-type-ranking-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .content-title {
      color: $gj-font-color-grey6;
      font-size: 15px;
    }
    .content-inner {
      color: #333;
      font-size: 17px;
      margin-top: 5px;
      margin-bottom: 3px;
      font-weight: 500;
      display: flex;
      .icon-inner {
        display: flex;
        align-items: center;
        margin-left: 5px;
      }
      .is-success {
        color: $gj-color-success;
      }
      .is-danger {
        color: $gj-color-danger;
      }
    }
  }
  .chart-type-ranking-content {
    margin-left: 20px;
  }
  &.chart-type-ranking-seller {
    .left-label-type {
     &::before {
       background: $gj-color-success !important;
     } 
    }
  }
}
</style>